export const handelOpenModalMyOrders = () => ({
    type: 'OPEN_MODAL_MY_ORDERS'
});
export const handelCloseModalMyOrders = () => ({
    type: 'CLOSE_MODAL_MY_ORDERS'
});
export const actionChangeLoaderMyOrders = (loader) => ({
    type: 'CHANGE_LOADER_MODAL_MY_ORDERS',loader
});
export const actionDataMyOrders = (contents,total_rows,offset) => ({
    type: 'CHANGE_DATA_MY_ORDERS',contents,total_rows,offset
});
export const actionChangeTextSurveyRealTime = (id,text) => ({
    type: 'CHANGE_TEXT_SURVEY_REAL_TIME',id,text
});